import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-wrapper__header" }
const _hoisted_2 = { class: "card-wrapper__plant_title text-truncate" }
const _hoisted_3 = { class: "card-wrapper__top_actions" }
const _hoisted_4 = { class: "bt-icon bt-icon--sm" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { class: "bt-icon bt-icon--sm" }
const _hoisted_7 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_8 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_9 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_10 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_11 = { class: "btn-stripped d-flex align-items-center text-danger" }
const _hoisted_12 = { class: "card-wrapper__body" }
const _hoisted_13 = { class: "card-wrapper__thumb" }
const _hoisted_14 = {
  key: 0,
  class: "bt-icon rotate-animation"
}
const _hoisted_15 = {
  key: 1,
  class: "bt-icon"
}
const _hoisted_16 = { class: "card-wrapper__details" }
const _hoisted_17 = {
  key: 1,
  class: "card-wrapper__address two-rows-ellipsis"
}
const _hoisted_18 = { class: "card-wrapper__tags" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "card-wrapper__footer" }
const _hoisted_21 = { class: "card-wrapper__updated" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "text-truncate mr-3"
}
const _hoisted_24 = { class: "list-bubbles" }
const _hoisted_25 = { class: "bt-icon bt-icon--sm" }
const _hoisted_26 = {
  key: 0,
  class: "card-wrapper__disabled-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_ElPopover = _resolveComponent("ElPopover")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", {
    class: ["card-wrapper", { 'card-wrapper--locked': _ctx.isSessionLocked }],
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleGoToPlantDetail && _ctx.handleGoToPlantDetail(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.plant.name), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", null, [
          _createVNode(_component_Button, {
            class: "p-button-text p-1",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.togglePlantFromFavorites($event)), ["stop"])),
            disabled: _ctx.isSessionLocked
          }, {
            default: _withCtx(() => [
              _createVNode("span", _hoisted_4, [
                _createVNode(_component_InlineSvgScoped, {
                  src: _ctx.favouriteIcon,
                  "aria-label": _ctx.favouriteIcon
                }, null, 8, ["src", "aria-label"])
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_ElDropdown, {
            trigger: "click",
            placement: "bottom-end",
            "popper-class": "el-dropdown__popper el-dropdown--context"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElDropdownItem, { onClick: _ctx.handleDuplicateCard }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_7, [
                        _createVNode("span", _hoisted_8, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                                    require('@/assets/images/icons/icon-duplication.svg')
                                                ,
                            "aria-label": "icon-duplication"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("span", null, _toDisplayString(_ctx.$t(
                                                "AppResource.Duplicate"
                                            )), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ElDropdownItem, {
                    onClick: _ctx.handleEdit,
                    disabled: !_ctx.plantEditListEnabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_9, [
                        _createVNode("span", _hoisted_10, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                                    require('@/assets/images/icons/icon-edit.svg')
                                                ,
                            "aria-label": "icon-edit"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]),
                  _createVNode(_component_ElDropdownItem, {
                    onClick: _ctx.handleDelete,
                    disabled: !_ctx.plantDeleteListEnabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_11, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleOptionsClick($event)), ["stop"])),
                class: "p-button-text p-1",
                disabled: _ctx.isSessionLocked
              }, {
                default: _withCtx(() => [
                  _createVNode("span", _hoisted_6, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: 
                                        require(`@/assets/images/icons/icon-ellipsis-v.svg`)
                                    ,
                      "aria-label": "icon-ellipsis-v"
                    }, null, 8, ["src"])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _createVNode("img", {
          src: _ctx.imageURLs[0],
          srcset: _ctx.imageSrcSetURLs,
          alt: "img"
        }, null, 8, ["src", "srcset"]),
        _createVNode("span", {
          class: ["card-wrapper__overlay text-primary", { 'is--visible': _ctx.showOverlay }]
        }, [
          (_ctx.overlayIcon)
            ? (_openBlock(), _createBlock("span", _hoisted_14, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                require(`@/assets/images/icons/${_ctx.overlayIcon}.svg`)
                            ,
                  "aria-label": "icon-sync"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSessionLocked)
            ? (_openBlock(), _createBlock("span", _hoisted_15, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                require(`@/assets/images/icons/icon-ban-light.svg`)
                            ,
                  "aria-label": "icon-sync"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createVNode("div", _hoisted_16, [
        (_ctx.computePlantAddress.length >= 57)
          ? _withDirectives((_openBlock(), _createBlock("p", {
              key: 0,
              class: "card-wrapper__address two-rows-ellipsis"
            }, _toDisplayString(_ctx.computePlantAddress), 513)), [
              [
                _directive_tooltip,
                _ctx.computePlantAddress,
                void 0,
                { top: true }
              ]
            ])
          : (_openBlock(), _createBlock("p", _hoisted_17, _toDisplayString(_ctx.computePlantAddress), 1)),
        _createVNode("ul", _hoisted_18, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.computedTags.list, (tag) => {
            return (_openBlock(), _createBlock("li", { key: tag }, _toDisplayString(tag.value), 1))
          }), 128)),
          (_ctx.computedTags.extraTags)
            ? (_openBlock(), _createBlock("li", _hoisted_19, _toDisplayString(_ctx.computedTags.extraTags), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode("div", _hoisted_21, [
        (!_ctx.isSessionLocked)
          ? (_openBlock(), _createBlock("span", _hoisted_22, [
              _createTextVNode(_toDisplayString(_ctx.$t("general.modified")) + ": ", 1),
              _createVNode("time", null, _toDisplayString(_ctx.formattedUpdateDate), 1)
            ]))
          : (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(_ctx.sessionLockedByName) + " " + _toDisplayString(_ctx.$t("isEditingPlant")), 1)),
        _createVNode("span", _hoisted_24, [
          _createVNode(_component_ElPopover, {
            placement: "top",
            trigger: "hover",
            title: _ctx.username,
            "popper-class": "el-popover--dark el-popover--slim"
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_Button, {
                disabled: "",
                class: "p-button-rounded p-button-sm p-button-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.userInitials), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_ElPopover, {
            placement: "top",
            trigger: "hover",
            title: _ctx.iconDeviceLabel,
            "popper-class": "el-popover--dark el-popover--slim"
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_Button, {
                disabled: "",
                class: "p-button-rounded p-button-icon-only p-button-sm p-button-secondary"
              }, {
                default: _withCtx(() => [
                  _createVNode("span", _hoisted_25, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: 
                                            require(`@/assets/images/icons/${_ctx.iconDevice}.svg`)
                                        ,
                      "aria-label": _ctx.iconDevice
                    }, null, 8, ["src", "aria-label"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ]),
      (_ctx.showOverlay)
        ? (_openBlock(), _createBlock("span", _hoisted_26))
        : _createCommentVNode("", true)
    ])
  ], 2))
}